globalThis.__VUE_OPTIONS_API__ = true;
globalThis.__VUE_PROD_DEVTOOLS__ = true;

import '../scss/recipes.scss';

import accordion from './scripts/accordion.js'
import tabs from './scripts/tabs.js'

// console.log('recipes');

window.addEventListener("DOMContentLoaded", function(event) {
	window.filterMode = 'recipes';
});

accordion();
tabs();